/* ============================================
   SAVAGE LANDING PAGE — Core JavaScript
   ============================================ */

(function () {
  'use strict';

  /* ---- Image Gallery ---- */
  function initImageGallery() {
    var container = document.querySelector('.savage-hero__left');
    if (!container) return;

    var mainImg = container.querySelector('.savage-hero__main-image img');
    var thumbs = Array.from(container.querySelectorAll('.savage-hero__thumbnail'));
    var prevBtn = container.querySelector('[data-thumb-prev]');
    var nextBtn = container.querySelector('[data-thumb-next]');
    var thumbStrip = container.querySelector('.savage-hero__thumbnails');
    if (!mainImg || !thumbs.length) return;

    var currentIndex = 0;

    function goTo(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;

      var thumbEl = thumbs[index];
      var thumbImg = thumbEl.querySelector('img');
      if (!thumbImg) return;

      // Use data-full-src if available, otherwise swap width param in Shopify CDN URL
      var fullSrc = thumbEl.getAttribute('data-full-src');
      var largeSrc = fullSrc || thumbImg.src.replace(/width=\d+/, 'width=800');
      mainImg.src = largeSrc;
      mainImg.alt = thumbImg.alt;

      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[index].classList.add('is-active');

      // Scroll thumbnail into view
      if (thumbStrip) {
        thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    // Thumbnail clicks
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    // Arrow buttons
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });
  }

  /* ---- Accordion (FAQ) ---- */
  function initAccordions() {
    var triggers = document.querySelectorAll('[data-savage-accordion-trigger]');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-savage-accordion-item]');
        if (!item) return;
        var isOpen = item.classList.contains('is-open');
        // Close siblings
        var parent = item.parentElement;
        if (parent) {
          parent.querySelectorAll('[data-savage-accordion-item].is-open').forEach(function (sibling) {
            sibling.classList.remove('is-open');
            var content = sibling.querySelector('[data-savage-accordion-content]');
            if (content) content.style.maxHeight = '0';
          });
        }
        // Toggle current
        if (!isOpen) {
          item.classList.add('is-open');
          var content = item.querySelector('[data-savage-accordion-content]');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Tabs (Timeline, etc.) ---- */
  function initTabs() {
    var tabGroups = document.querySelectorAll('[data-savage-tabs]');
    tabGroups.forEach(function (group) {
      var buttons = group.querySelectorAll('[data-savage-tab]');
      var panels = group.querySelectorAll('[data-savage-tab-panel]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var target = btn.getAttribute('data-savage-tab');
          buttons.forEach(function (b) { b.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var panel = group.querySelector('[data-savage-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  /* ---- Sticky Footer CTA ---- */
  function initStickyFooter() {
    var footer = document.querySelector('[data-savage-sticky-footer]');
    var hero = document.querySelector('.savage-hero');
    if (!footer || !hero) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          footer.classList.remove('is-visible');
        } else {
          footer.classList.add('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  /* ---- Smooth Scroll ---- */
  // Height of any sticky/fixed top bar (savage-nav) so anchor targets aren't
  // hidden underneath it.
  function savageStickyOffset() {
    var offset = 0;
    document.querySelectorAll('.savage-nav').forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var h = el.getBoundingClientRect().height;
        if (h > 0 && h < 160) offset = Math.max(offset, h);
      }
    });
    return offset;
  }

  // Smooth-scroll to an anchor target and KEEP re-aiming while the page settles.
  // Lazy images loading in the scroll path grow the content above the target
  // mid-animation; a one-shot scrollIntoView commits to the click-time position
  // and lands short (on the wrong section). This follows the moving target and
  // bails the instant the user takes over.
  function savageScrollToTarget(target) {
    var docTop = function () {
      return Math.round(target.getBoundingClientRect().top + window.scrollY);
    };
    var go = function () {
      window.scrollTo({ top: Math.max(0, docTop() - savageStickyOffset() - 8), behavior: 'smooth' });
    };
    var tries = 0, lastY = -1, done = false;
    function stop() { done = true; cleanup(); }
    function onKey(ev) {
      if (['PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'Home', 'End', ' '].indexOf(ev.key) !== -1) stop();
    }
    function cleanup() {
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', onKey);
    }
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.addEventListener('keydown', onKey);
    go();
    (function correct() {
      if (done) return;
      var y = docTop();
      if (Math.abs(y - lastY) > 2) { go(); lastY = y; }
      if (++tries < 14) { setTimeout(correct, 150); } else { cleanup(); }
    })();
  }

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetId = link.getAttribute('href');
        if (!targetId || targetId === '#') return;
        var target = document.querySelector(targetId);
        if (!target) return;
        e.preventDefault();
        savageScrollToTarget(target);
      });
    });
  }

  /* ---- Add to Cart ---- */
  function initAddToCart() {
    document.querySelectorAll('[data-savage-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = btn.getAttribute('data-variant-id');
        var sellingPlan = btn.getAttribute('data-selling-plan') || '';
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = 'Adding...';

        var body = {
          id: parseInt(variantId, 10),
          quantity: 1
        };
        if (sellingPlan) body.selling_plan = parseInt(sellingPlan, 10);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json(); })
          .then(function (item) {
            btn.textContent = 'Added!';
            // Always sync every cart-count badge from the authoritative cart.
            // The visible nav badge (.savage-nav__cart-count) lives OUTSIDE Dawn's
            // #cart-icon-bubble, so renderContents alone leaves it stale until a
            // page refresh. Update all [data-cart-count] plus Dawn's default
            // .cart-count-bubble so every header variant stays in sync.
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                });
                var bubble = document.querySelector('.cart-count-bubble');
                if (bubble) {
                  var span = bubble.querySelector('span[aria-hidden]');
                  if (span) span.textContent = cart.item_count;
                }
              })
              .catch(function () {});
            // Render + open Dawn's cart drawer (updates drawer contents + hidden bubble).
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              if (cartDrawer.classList.contains('is-empty')) {
                cartDrawer.classList.remove('is-empty');
              }
              var sectionsUrl = '/?sections=cart-drawer,cart-icon-bubble';
              fetch(sectionsUrl)
                .then(function (r) { return r.json(); })
                .then(function (sections) {
                  cartDrawer.renderContents({ id: item.id, sections: sections });
                });
            }
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = btn.getAttribute('data-original-text') || 'Add to Cart';
            }, 2000);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-original-text') || 'Add to Cart';
          });
      });
    });
  }

  /* ---- Nutrition Facts Modal ---- */
  function initNutritionModal() {
    var modal = document.getElementById('savage-nutrition-modal');
    if (!modal) return;

    var openBtns = document.querySelectorAll('[data-nutrition-open]');
    var closeBtns = modal.querySelectorAll('[data-nutrition-close]');

    function open(e) {
      e.preventDefault();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });

    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---- Review Slider ---- */
  function initReviewSlider() {
    var slider = document.querySelector('[data-review-slider]');
    if (!slider) return;

    var track = slider.querySelector('.savage-hero__review-track');
    var slides = Array.from(slider.querySelectorAll('.savage-hero__review-slide'));
    var dots = Array.from(slider.querySelectorAll('[data-review-dot]'));
    if (slides.length < 2) return;

    var current = 0;
    var interval = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    function prev() {
      goTo((current - 1 + slides.length) % slides.length);
    }

    function next() {
      goTo((current + 1) % slides.length);
    }

    function resetAuto() {
      clearInterval(interval);
      interval = setInterval(next, 5000);
    }

    // Dot clicks
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-review-dot'), 10));
        resetAuto();
      });
    });

    // Drag / swipe support
    var startX = 0;
    var dragging = false;
    var threshold = 40;

    function onPointerDown(e) {
      dragging = true;
      startX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      clearInterval(interval);
    }

    function onPointerUp(e) {
      if (!dragging) return;
      dragging = false;
      var endX = e.clientX || (e.changedTouches && e.changedTouches[0].clientX) || 0;
      var diff = endX - startX;
      if (Math.abs(diff) > threshold) {
        if (diff < 0) next(); else prev();
      }
      resetAuto();
    }

    // Mouse events
    track.addEventListener('mousedown', onPointerDown);
    document.addEventListener('mouseup', onPointerUp);

    // Touch events
    track.addEventListener('touchstart', onPointerDown, { passive: true });
    document.addEventListener('touchend', onPointerUp);

    // Prevent text selection while dragging
    track.style.cursor = 'grab';
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    interval = setInterval(next, 5000);
  }

  /* ---- Initialize Everything ---- */
  /* ---- Choose Offer selector ---- */
  function initChooseOffer() {
    var CHECK = '<svg width="16" height="16" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="10" fill="#4caf50"/><path d="M6 10.5l2.5 2.5L14 7.5" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function parseJSON(str, fallback) {
      try { return JSON.parse(str); } catch (e) { return fallback; }
    }
    document.querySelectorAll('[data-savage-choose-offer]').forEach(function (root) {
      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-offer]'));
      if (!opts.length) return;
      var cta = root.querySelector('[data-savage-choose-cta]');
      var benefitsList = root.querySelector('[data-benefits-list]');
      var giftHead = root.querySelector('[data-gift-head]');
      var giftList = root.querySelector('[data-gift-list]');
      var ctaSub = root.querySelector('[data-cta-sub]');

      function apply(opt) {
        opts.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');

        var variant = opt.getAttribute('data-variant') || '';
        var plan = opt.getAttribute('data-plan') || '';
        var price = opt.getAttribute('data-price') || '';
        var cycle = opt.getAttribute('data-cycle') || '';
        var giftCount = opt.getAttribute('data-gift-count') || '';
        var giftValue = opt.getAttribute('data-gift-value') || '';
        var gifts = parseJSON(opt.getAttribute('data-gifts'), []);
        var benefits = parseJSON(opt.getAttribute('data-benefits'), []);

        if (cta) {
          cta.setAttribute('data-variant-id', variant);
          if (plan) { cta.setAttribute('data-selling-plan', plan); }
          else { cta.removeAttribute('data-selling-plan'); }
        }
        if (ctaSub) {
          ctaSub.textContent = '$' + price + (cycle ? ' ' + cycle : '') + ' · cancel anytime';
        }
        if (giftHead) {
          giftHead.textContent = 'Your ' + giftCount + ' Premium Gifts · worth $' + giftValue;
        }
        if (giftList) {
          giftList.innerHTML = gifts.map(function (g) {
            return '<li><span class="savage-choose-offer__g-name">' + CHECK + g.n + '</span>'
              + '<span class="savage-choose-offer__g-was">$' + g.w + '</span>'
              + '<span class="savage-choose-offer__g-free">FREE</span></li>';
          }).join('');
        }
        if (benefitsList) {
          benefitsList.innerHTML = benefits.map(function (b) {
            return '<li>' + CHECK + '<span>' + b + '</span></li>';
          }).join('');
        }
      }

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { apply(opt); });
      });
      apply(root.querySelector('[data-offer].is-selected') || opts[0]);
    });
  }

  function init() {
    initImageGallery();
    initAccordions();
    initTabs();
    initStickyFooter();
    initSmoothScroll();
    initAddToCart();
    initNutritionModal();
    initReviewSlider();
    initChooseOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
